import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { QueryStatus, authAxios } from "../../../utils";
import { RootState } from "../../../redux/store";
import { LinkyConsent } from "./linkyConsentsAPI";
import { fakeLinkyConsents } from "./linkyConsentsFakeData";

export interface LinkyConsentsState {
  linkyConsentsStatus: QueryStatus;
  linkyConsents: LinkyConsent[];
  addHomeChargingDriversStatus: QueryStatus;
}

const initialState: LinkyConsentsState = {
  linkyConsentsStatus: "idle",
  linkyConsents: [],
  addHomeChargingDriversStatus: "idle",
};

export const getLinkyConsentsAsync = createAsyncThunk(
  "getLinkyConsentsAsync/call",
  () => {
    return fakeLinkyConsents;
  },
);

export const addHomeChargingDriversAsync = createAsyncThunk(
  "addHomeChargingDrivers/call",
  async (driverUuids: string[], thunkAPI) => {
    const company = (thunkAPI.getState() as RootState).home.company;
    if (!company) throw new Error("Company not selected");
    const axios = authAxios({ companyUuid: company.uuid });
    await axios.post(`electric_charges/drivers/company/${company.uuid}`, {
      drivers: driverUuids.map((uuid) => ({ uuid })),
    });
  },
);

export const linkyConsentsSlice = createSlice({
  name: "linkyConsents",
  initialState,
  reducers: {
    resetLinkyConsentsStatus(state) {
      state.linkyConsentsStatus = "idle";
    },
    resetAddHomeChargingDriversStatus(state) {
      state.addHomeChargingDriversStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLinkyConsentsAsync.pending, (state) => {
        state.linkyConsentsStatus = "processing";
      })
      .addCase(getLinkyConsentsAsync.fulfilled, (state, action) => {
        state.linkyConsentsStatus = "success";
        state.linkyConsents = action.payload;
      })
      .addCase(getLinkyConsentsAsync.rejected, (state) => {
        state.linkyConsentsStatus = "failed";
      })
      .addCase(addHomeChargingDriversAsync.pending, (state) => {
        state.addHomeChargingDriversStatus = "processing";
      })
      .addCase(addHomeChargingDriversAsync.fulfilled, (state) => {
        state.addHomeChargingDriversStatus = "success";
      })
      .addCase(addHomeChargingDriversAsync.rejected, (state) => {
        state.addHomeChargingDriversStatus = "failed";
      });
  },
});

export const selectLinkyConsentsStatus = (state: RootState) =>
  state.linkyConsents.linkyConsentsStatus;

export const selectLinkyConsents = (state: RootState) =>
  state.linkyConsents.linkyConsents;

export const selectAddHomeChargingDriversStatus = (state: RootState) =>
  state.linkyConsents.addHomeChargingDriversStatus;

export default linkyConsentsSlice.reducer;
